import { Icon, Image } from '@acme/assets';
import { Card } from 'flowbite-react';
import type { ActionResultData } from '../model/kinds';

export type ActionResultScreenProps = {
  isError: boolean;
  applicationCode?: string | null;
  actionName?: string | null;
  customResult?: ActionResultData;
  onBack: () => void;
};

export const ActionResultScreen = ({
  isError,
  applicationCode,
  actionName,
  customResult,
  onBack,
}: ActionResultScreenProps) => {
  const title =
    customResult?.title ??
    (applicationCode && actionName
      ? isError
        ? `Действие для заявки ${applicationCode} завершилось с ошибкой`
        : `Действие для заявки ${applicationCode} успешно выполнено`
      : isError
        ? 'Произошла ошибка'
        : 'Действие успешно выполнено');

  const content = customResult?.content;

  return (
    <div className="w-full h-full flex items-center justify-center min-w-112">
      <Card className="p-6 flex flex-col justify-center items-center max-w-xl">
        <div className="flex justify-center items-center">
          {isError ? (
            <div className="p-4 rounded-full text-red-600 bg-red-100 flex items-center justify-center">
              <Icon size={24} name="x-outline" />
            </div>
          ) : (
            <Image name="application-succes" width={160} height={160} />
          )}
        </div>
        <div className="text-center">
          <div className="font-medium">{title}</div>
          {content && <div className="text-gray-500">{content}</div>}
        </div>
        <div className="text-center items-center flex w-full">
          <div
            className="flex justify-center items-center gap-1 cursor-pointer mx-auto"
            onClick={onBack}
          >
            <Icon name="arrow-left" />{' '}
            {customResult?.linkText ?? 'Вернуться к заявке'}
          </div>
        </div>
      </Card>
    </div>
  );
};
